import { render } from "./Comment.vue?vue&type=template&id=fa1b8578"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=fa1b8578&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__